<template>
  <div>
  <span class="cap">打球位置:</span>
  <span v-if="isServe">
    {{ CmnConst.hitPostionAtServe[hitPosition] }}
  </span>
  <span v-else>
    {{ CmnConst.hitPostion[hitPosition] }}
  </span><br />
  {{ CmnConst.handList[hand] }}<br/>
  <span v-if="isServe">
    <span class="cap">サーブ:</span>{{ CmnConst.serveList[hitStyle] }}
  </span>
  <span v-else>
    <span class="cap">打法:</span>{{ CmnConst.hitsStyleList[hitStyle] }}
  </span><br />
  <span class="cap">コース:</span>{{ CmnConst.courseList[course] }}<br/>
  <span v-if="inOut && inOutDetail !== 0">{{ CmnConst.inList[inOutDetail] }}</span>
  <span v-else-if="!inOut" class="text-danger">{{ CmnConst.outList[inOutDetail] }}</span>
  </div>
</template>

<script>
import CmnConst from '@/lib/cmnConst';

export default {
  name: 'hitsTableCell',
  props: ['isServe', 'hitPosition', 'hand', 'hitStyle', 'course', 'inOutDetail', 'inOut'],
  data() {
    return {
      CmnConst,
    };
  },
};
</script>

<style scoped>
.cap{
  font-size: 0.7em;
}


</style>



// WEBPACK FOOTER //
// src/components/atoms/HitTableCell.vue